import React, { useState, useEffect, useRef, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import {
  questinnare1,
  questinnare2Very,
  questinnaire76Vanquis,
  questinnaire36Vanquis
} from "../../../../Constants/Questions";
import QuestionnaireFlpFANUpload from "../Followup/QuestionnaireFlpFANUpload";
import { useHistory } from "react-router-dom";
import QuestionnaireFlpAgreementNo from "./Vanquis/QuestionnaireFlpAgreementNo";
import AccountCloseYear from "./Vanquis/AccountCloseYear";
import HighestBalance from "./Vanquis/HighestBalance";
import HowManyTimes from "./Vanquis/HowManyTimes";
import HowOften from "./Vanquis/HowOften";
import MinimumPayment from "./Vanquis/MinimumPayment";
import LoanModal from "./Vanquis/LoanModal";
import MonthlyModal from "./Vanquis/MonthlyModal";
import QuestionnaireEmail from "./Vanquis/QuestionnaireEmail";
import EmailConfirmation from "./Vanquis/EmailConfirmation";
import QuestionnaireSupportDoc from "./Vanquis/QuestionnaireSupportDoc";
import { useUserVerify } from "../../../../Hooks/useUserVerify";
import { userMilestoneUpdate } from "../../../../Hooks/userMilestoneUpdate";
import { queryString } from "../../../../Utility/QueryString";
import QuestionnaireFooter from "./QuestionnaireFooter";
import QuestionnaireFlpAgreementNoModalV2 from "../FollowupS1/QuestionnaireFlpAgreementNoModalV2";
import IsStillActive from "./Vanquis/IsStillActive";
import RecentCreditIncrease from "./Vanquis/RecentCreditLimit";
import WhatYearHappen from "./Vanquis/WhatYearHappen";
import SoldDebtOn from "./Vanquis/SoldDebtOn";
import Bankruptcy from "./Vanquis/Bankrupty";
import Filed from "./Vanquis/Filled";
import { useSkippedLeads } from "../../../../Hooks/useSkippedLeads";
import EmployementStatus from "./Vanquis/EmployementStatus";
import DependentStatus from "./Vanquis/Dependent";
import AnalyzeModal from "./AnalayzeModal";
import ConfirmSitution from "./Vanquis/ConfirmSitution";
import IncomeConfirmationVAQ_UB_4 from "./Vanquis/IncomeConfirmationVAQ_UB_4";
import IncomeExpense_VAQ_UB_4 from "./Vanquis/IncomeExpense_VAQ_UB_4";
import Question36 from "./Vanquis/Question36_VAQ_UB_4";
import { Api } from "../../../../api/Api";

const initialState = {
  Bankrupty: "hide",
  claimfilled: "hide",
  confirm_sitution :"hide",
  slide_stillactive: "hide",
  slide_recentcreditlimit: "hide",
  soldon_dept: "hide",
  whatyear_happen: "hide",
  employment_status: "hide",
  dependent_status: "hide",
  showSlide1: "hide",
  showSlide1a: "hide",
  showSlide2: "hide",
  showSlide3: "hide",
  showSlide4: "hide",
  showSlide5: "hide",
  showSlide6: "hide",
  incomeConfirmation:"hide",
  showSlide7: "hide",
  showSlide8: "hide",
  showSlide9: "hide",
  showSlide9a: "hide",
  showSlide10: "hide",
  loanModal: "hide",
  monthlyModal: "hide",
};
const QuestionnaireReducer = (state, action) => {
  switch (action.type) {
    case "showSlideChange": {
      if (action.payload == "Bankrupty") {
        return {
          ...state,
          Bankrupty: "show",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 10,
        };
      } else if (action.payload == "claimfilled") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "show",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 15,
        };
      } 
       else if (action.payload == "slide_stillactive") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "show",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 20,
        };
      } else if (action.payload == "slide_recentcreditlimit") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "show",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 25,
        };
      } else if (action.payload == "soldon_dept") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "show",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 30,
        };
      } else if (action.payload == "whatyear_happen") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "show",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 35,
        };
      } else if (action.payload == "employment_status") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "show",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 40,
        };
      } else if (action.payload == "dependent_status") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "show",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 45,
        };
      } else if (action.payload == "slide1") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          employment_status: "hide",
          showSlide1: "show",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          dependent_status: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 50,
        };
      } else if (action.payload == "slide1a") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          showSlide1: "hide",
          showSlide1a: "show",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 55,
        };
      } else if (action.payload == "slide2") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "show",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 60,
        };
      } else if (action.payload == "slide3") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "show",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 65,
        };
      } else if (action.payload == "slide4") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "show",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 70,
        };
      } else if (action.payload == "slide5") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "show",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 75,
        };
      } else if (action.payload == "incomeConfirmation") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          incomeConfirmation:"show",
          showSlide6: "hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 80,
        };
      } 
      else if (action.payload == "slide6") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "show",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 80,
        };
      } 
      else if (action.payload == "slide7") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "show",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 85,
        };
      } else if (action.payload == "slide8") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "show",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 90,
        };
      } else if (action.payload == "confirm_sitution") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"show",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 91,
        };
      } else if (action.payload == "slide9") {
        window.scrollTo(0,0);
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "show",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 92,
        };
      } else if (action.payload == "slide9a") {
        window.scrollTo(0,0);
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "show",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 94,
        };
      } else if (action.payload == "slide10") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "show",
          loanModal: "hide",
          monthlyModal: "hide",
          percentage: 95,
        };
      } else {
        return {
          ...state,
        };
      }
    }
    case "expenseModal": {
      if (action.payload == "loanModal") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "show",
          monthlyModal: "hide",
        };
      } else if (action.payload == "monthlyModal") {
        return {
          ...state,
          Bankrupty: "hide",
          claimfilled: "hide",
          confirm_sitution :"hide",
          slide_stillactive: "hide",
          slide_recentcreditlimit: "hide",
          soldon_dept: "hide",
          whatyear_happen: "hide",
          employment_status: "hide",
          dependent_status: "hide",
          showSlide1: "hide",
          showSlide1a: "hide",
          showSlide2: "hide",
          showSlide3: "hide",
          showSlide4: "hide",
          showSlide5: "hide",
          showSlide6: "hide",
          incomeConfirmation:"hide",
          showSlide7: "hide",
          showSlide8: "hide",
          showSlide9: "hide",
          showSlide9a: "hide",
          showSlide10: "hide",
          loanModal: "hide",
          monthlyModal: "show",
        };
      } else {
        return {
          ...state,
        };
      }
    }
  }
};
const VanquisQuestionForm = ({
  lender,
  questionsPop,
  allFollowupData,
  pendingQuestionnaire,
  splitName,
  currentUuid,
  documentType,
  docType,
  sett2aValidation,
  setPendingStatus,
  accClsYear,
  splitData,
  t2aApiReqData,
  t2aStatus,
  setDivShow,
}) => {
  const history = useHistory();
  const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [completedQuestArr, setCompletedQuestArr] = useState([]);
  const { saveFollowupUserQuestions, isLoading } = useFollowupUserQuestions();
  const splitForm = useRef(null);
  const [optionSelected] = useState([]);
  const [optionSelected76] = useState([]);

  const { getUserVerfyValidation, saveFollowupUserVerify } = useUserVerify();
  const { updateMilestone } = userMilestoneUpdate();
  const [agNoShow, setAgNoShow] = useState("hide");
  const { skippedLeads, skippedLeadsFLP } = useSkippedLeads();
  const [t2aModal,SetT2aModal]=useState(false);

  const { register, errors, trigger, setError, clearErrors, getValues } =
    useForm({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {},
      resolver: undefined,
      context: undefined,
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: true,
    });

  useEffect(() => {
    setShow(questionsPop);
  }, [questionsPop]);

  useEffect(() => {
    slideChange(pendingQuestionnaire);
  }, [pendingQuestionnaire]);

  const slideChange = (pendingArr) => {
    let pendingCount = pendingArr.length;
    if (pendingCount == 0) {
      if(splitData.signStatus == 1){
        const responsepdf = Api.get(
          "/api/v1/pdf-re-generate?uuid=" + currentUuid,
          {}
        );
      }
      setShow(false);
      sendT2aApiReqDataAPI();
    }

    pendingArr.every((element) => {
      dispatch({ type: "showSlideChange", payload: element });
    });
  };
  const storeFollowupQuestionnire = async (question_data) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );
  };

  const onselectAnswer = async (e) => {
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    let anslabel = e.target.getAttribute("data-ans-label");
    let flage = false;
    let question_data = {};
    const valuesreg = getValues();

    let employment = valuesreg["employment"];

    if (e.target.name == "btn_qest_2" && employment) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: employment,
        answer_text: anslabel,
        input_answer: "",
      };
      removeFromPending("employment_status");
    }
    if (e.target.name == "question_3") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("dependent_status");
    }
    if (e.target.name == "question_9") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("Bankrupty");
    }
    if (e.target.name == "question_30") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("claimfilled");
    }
    if (e.target.name == "question_54") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("slide3");
    }
    if (e.target.name == "question_71") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      if (selectedAns == 206) {
        removeFromPending("soldon_dept");
      } else if (selectedAns == 207) {
        removeFromPending("soldon_dept");
        removeFromPending("whatyear_happen");
      }
    } else if (e.target.name == "question_26") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      if (selectedAns == 96) {
        removeFromPending("slide_stillactive");
        removeFromPending("slide_recentcreditlimit");
      } else if (selectedAns == 95) {
        removeFromPending("slide_stillactive");
        removeFromPending("slide1a");
      }
    } else if (e.target.name == "question_75") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      if (selectedAns == 213) {
        removeFromPending("incomeConfirmation");
      } else if (selectedAns == 214) {
        removeFromPending("incomeConfirmation");
        removeFromPending("slide6");
      }
    }  else if (e.target.name == "question_55") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("slide4");
    } else if (e.target.name == "question_56") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
      removeFromPending("slide5");
    } else if (e.target.name == "btn_qest_36") {
      if (selectedQuest) {
        flage = true;
        question_data = {
          question_id: 36,
          option_id: null,
          answer_text: anslabel,
          input_answer: optionSelected,
        };
      }
      removeFromPending("slide9");
    } else if (e.target.name == "btn_qest_76") {
      if (selectedQuest) {
        flage = true;
        question_data = {
          question_id: 76,
          option_id: null,
          answer_text: anslabel,
          input_answer: optionSelected76,
        };
      }
      removeFromPending("confirm_sitution");
    } else if (e.target.name == "question_61") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
        if (selectedAns == 162) {
          removeFromPending("slide8");
        }
      }
      removeFromPending("slide7");
    } else if (e.target.name == "question_42") {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
        if (selectedAns == "124") {
          setAgNoShow("show");
        } else if (selectedAns == "123") {
          pushPageChange();          
          removeFromPending("slide9a");
        } else {
          removeFromPending("slide9a");
        }
      }
    } else {
      if (selectedAns && selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: selectedAns,
          answer_text: anslabel,
          input_answer: "",
        };
      }
    }

    if (flage) {
      storeFollowupQuestionnire(question_data);
      var existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (existingEntries == null) existingEntries = [];
      localStorage.setItem(
        "currentquestionData",
        JSON.stringify(question_data)
      );
      existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(existingEntries));
    }
  };
  const handleT2AResult = () => {
    const t2aResult = localStorage.getItem("t2a_result");

    if (t2aResult) {
      if (t2aResult == 1) {
        history.push("/PreviewVAQ4?uuid=" + currentUuid);
      } else {
        setDivShow("idUpload");
      }
    } else {
      if (t2aStatus == 0) {
        setDivShow("idUpload");
      } else {
        history.push("/PreviewVAQ4?uuid=" + currentUuid);
      }
    }
  };

  const saveIncomeExpenditure = async (e) => {
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    const values = getValues();
    setCompletedQuestArr([...completedQuestArr, selectedQuest, 32, 33, 35]);

    var answer31 = splitForm.current["question_31"].value;
    var answer32 = splitForm.current["question_32"].value;
    var answer33 = splitForm.current["question_33"].value;
    // var question_57 = splitForm.current["question_57"].value;
    // var question_58 = splitForm.current["question_58"].value;
    // var question_59 = values["question_59"];
    // var question_60 = values["question_60"];

    // if (question_57 == 151 && (question_59 == undefined || question_59 == "")) {
    //   dispatch({ type: "expenseModal", payload: "loanModal" });
    //   return false;
    // } 
    // else if (
    //   question_58 == 153 &&
    //   (question_60 == undefined || question_60 == "")
    // ) {
    //   dispatch({ type: "expenseModal", payload: "monthlyModal" });
    //   return false;
    // }
    //  else {
      var slide_array = [
        ["31", answer31],
        ["32", answer32],
        ["33", answer33],
        // ["57", question_57],
        // ["58", question_58],
      ];

      // if (question_59 != "") {
      //   slide_array.push(["59", question_59]);
      // }
      // if (question_60 != "") {
      //   slide_array.push(["60", question_60]);
      // }

      var question_data = {
        slide_4: slide_array,
      };
      removeFromPending("slide6");
      storeFollowupQuestionnire(question_data);

      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    // }
  };

  const saveInputAns = async (e) => {
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    setCompletedQuestArr([...completedQuestArr, selectedQuest]);
    const valuesreg = getValues();
    let highestBalance = valuesreg["highest_balance"];
    let sprt = valuesreg["value"];
    let agreementNo = valuesreg["question_45"];
    let modalagreementNo = valuesreg["modal_question_45"];
    let email = valuesreg["question_48"];
    let accCloseYr = valuesreg["question_52"];
    let creditIncrease = valuesreg["CreditIncrease"];
    let whatYearhappen = valuesreg["whatYearThisHappen"];
    let flage = false;
    let question_data = {};

    if (selectedQuest == "70" && creditIncrease) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: creditIncrease,
      };
      removeFromPending("slide_recentcreditlimit");
    }else if (e.target.name == "dontRecall") {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: "I Don't Recall",
      };
      removeFromPending("slide_recentcreditlimit");
    }

    if (selectedQuest == "72" && whatYearhappen) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: whatYearhappen,
      };
      removeFromPending("whatyear_happen");
    }

    if (selectedQuest == "45" && modalagreementNo) {
      pushPageChange();
      removeFromPending("slide9a");
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: modalagreementNo,
      };
      setAgNoShow("hide");
      //removeFromPending("slide9a");
      //pushPageChange();
    }
    if (selectedQuest == "45" && agreementNo) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: agreementNo,
      };
      removeFromPending("slide1");
    }

    if (selectedQuest == "52" && accCloseYr) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: accCloseYr,
      };
      removeFromPending("slide1a");
    }
    if (selectedQuest == "53" && highestBalance) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: highestBalance,
      };
      removeFromPending("slide2");
    }
    if (selectedQuest == "48" && email) {
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: email,
      };
      removeFromPending("slide8");
    }

    if (flage) {
      storeFollowupQuestionnire(question_data);
      var existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (existingEntries == null) existingEntries = [];
      localStorage.setItem(
        "currentquestionData",
        JSON.stringify(question_data)
      );
      existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(existingEntries));
    }
  };

  const removeFromPending = (slidename) => {
    const index = pendingQuestionnaire.indexOf(slidename);
    if (index > -1) {
      pendingQuestionnaire.splice(index, 1);
    }
    slideChange(pendingQuestionnaire);
  };

  const pushPageChange = () => {
    removeFromPending("slide10");
  };

  const sendT2aApiReqDataAPI = () => {
    SetT2aModal(true);
    const useruuid = t2aApiReqData.uuid;
    const fName = t2aApiReqData.fName;
    const lName = t2aApiReqData.lName;
    const pCode = t2aApiReqData.pCode;
    const addressLine1 = t2aApiReqData.addressLine1;
    const dobDay = t2aApiReqData.day;
    const dobMonth = t2aApiReqData.month;
    const dobYear = t2aApiReqData.year;
    const addressLine2 = t2aApiReqData.addressLine2;
    const postTown = t2aApiReqData.postTown;
    const country = t2aApiReqData.country;
    const title = t2aApiReqData.title;
    const addressLine3 = t2aApiReqData.addressLine3;
    const addressLine4 = t2aApiReqData.addressLine4;
    const county = t2aApiReqData.county;
    if (
      useruuid &&
      fName &&
      lName &&
      pCode &&
      addressLine1 &&
      t2aStatus == null
    ) {
      (async () => {
        const response = await getUserVerfyValidation(
          useruuid,
          fName,
          lName,
          pCode,
          addressLine1,
          dobYear,
          dobMonth,
          dobDay,
          addressLine2,
          postTown,
          country,
          title,
          addressLine3,
          addressLine4,
          county
        );
        storeT2aResponse(response?.data);
        if (response?.data?.status == "success") {
          SetT2aModal(false);
          localStorage.setItem("t2a_result", 1);
          localStorage.setItem("split_name", splitName);
          history.push("/PreviewVAQ4?uuid=" + currentUuid);
        } else {
          SetT2aModal(false);
          localStorage.setItem("t2a_result", 0);
          setDivShow("idUpload");
        }
      })();
    } else {
      localStorage.setItem("t2a_result", t2aStatus);
      SetT2aModal(false);
      let email_skip = localStorage.getItem("email_doc");
      if (useruuid && email_skip != 1) {
        (async () => {
          const response = await updateMilestone(
            useruuid,
            t2aStatus,
            allFollowupData
          );
        })();
      }

      if (t2aStatus == 1) {
        history.push("/PreviewVAQ4?uuid=" + currentUuid);
      } else {
        setDivShow("idUpload");
      }
    }
  };

  const storeT2aResponse = async (t2a_data) => {
    const response = await saveFollowupUserVerify(
      allFollowupData,
      t2a_data,
      "person_verify_store_flp",
      queryString,
      t2aApiReqData
    );
  };
  const skipAgNo = async (e) => {
    removeFromPending("slide9a");
    pushPageChange();
    setAgNoShow("hide");
    const skippedLeadsResponse = await skippedLeadsFLP(
      "SkipAgreementNoFlp",
      allFollowupData,
      splitName
    );
  };

  return (
    <>
      <div className="QuestionnaireV7">
        <div className="formsection">
          <div className="container">
            <div className="row">
              <form
                ref={splitForm}
                name="split_form"
                id="user_form"
                method="POST"
                autoComplete="off"
                //onSubmit={handleSubmit}
              >
                <div className="offset-xl-3 col-xl-6 offset-lg-3 col-lg-6 offset-md-2 col-md-8 col-12">
                  <div
                    className={`question1 animated fadeInUp space-top ${state.Bankrupty}`}
                    id="breakdown012"
                  >
                    <Bankruptcy
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.claimfilled}`}
                    id="breakdown013"
                  >
                    <Filed
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top ${state.slide_stillactive}`}
                    id="breakdown01bb"
                  >
                    <IsStillActive
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top ${state.slide_recentcreditlimit}`}
                    id="breakdown01aa"
                  >
                    <RecentCreditIncrease
                      saveInputAns={saveInputAns}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.showSlide1a}`}
                    id="breakdown1a"
                  >
                    <AccountCloseYear
                      lender={lender}
                      saveInputAns={saveInputAns}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.soldon_dept}`}
                    id="breakdown01ac"
                  >
                    <SoldDebtOn
                      lender={lender}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.whatyear_happen}`}
                    id="breakdown01ad"
                  >
                    <WhatYearHappen
                      lender={lender}
                      saveInputAns={saveInputAns}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top ${state.employment_status}`}
                    id="breakdown01ae"
                  >
                    <EmployementStatus
                      lender={lender}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.dependent_status}`}
                    id="breakdown01ae"
                  >
                    <DependentStatus
                      lender={lender}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitData={splitData}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.showSlide1}`}
                    id="breakdown01"
                  >
                    <QuestionnaireFlpAgreementNo
                      questArr={questinnare1}
                      labelclicked={onselectAnswer}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      saveInputAns={saveInputAns}
                    />
                  </div>

                  <div
                    className={`question1 animated fadeInUp space-top ${state.showSlide2}`}
                    id="breakdown1"
                  >
                    <HighestBalance
                      lender={splitData.lender}
                      saveInputAns={saveInputAns}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top2 ${state.showSlide3}`}
                    id="breakdown2"
                  >
                    <HowManyTimes
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top2 ${state.showSlide4}`}
                    id="breakdown3"
                  >
                    <HowOften
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top2 ${state.showSlide5}`}
                    id="breakdown4"
                  >
                    <MinimumPayment
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question1 animated fadeInUp space-top ${state.incomeConfirmation}`}
                    id="breakdown012"
                  >
                    <IncomeConfirmationVAQ_UB_4
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                    />
                  </div>
                  <div
                    className={`question6 animated fadeInUp space-top2 ${state.showSlide6}`}
                    id="breakdown5"
                  >
                    <IncomeExpense_VAQ_UB_4
                      questArr={questinnare1}
                      labelclicked={onselectAnswer}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      saveIncomeExpenditure={saveIncomeExpenditure}
                      splitForm={splitForm}
                    />
                  </div>
                  <div
                    className={`question7 animated fadeInUp space-top ${state.showSlide7}`}
                    id="breakdown9"
                  >
                    <EmailConfirmation
                      onselectAnswer={onselectAnswer}
                      userEmail={splitData.email}
                    />
                  </div>
                  <div
                    className={`question8 animated fadeInUp space-top ${state.showSlide8}`}
                    id="breakdown9"
                  >
                    <QuestionnaireEmail
                      validation={register}
                      getValues={getValues}
                      trigger={trigger}
                      validationMsg={errors}
                      saveInputAns={saveInputAns}
                      lender={splitData.lender}
                    />
                  </div>
                  <div
                    className={`question9 animated fadeInUp space-top2 ${state.confirm_sitution}`}
                    id="breakdow10"
                  >
                    <ConfirmSitution
                      questArr={questinnaire76Vanquis}
                      onselectAnswer={onselectAnswer}
                      optionSelected76={optionSelected76}
                    />
                  </div>
                  <div
                    className={`question9 animated fadeInUp space-top2 ${state.showSlide9}`}
                    id="breakdow10"
                  >
                    <Question36
                      questArr={questinnaire36Vanquis}
                      onselectAnswer={onselectAnswer}
                      optionSelected={optionSelected}
                    />
                  </div>
                  <div
                    className={`question9 animated fadeInUp space-top2 ${state.showSlide9a}`}
                    id="breakdow10"
                  >
                    <QuestionnaireSupportDoc
                      labelclicked={onselectAnswer}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      saveInputAns={saveInputAns}
                    />
                  </div>

                  <div
                    className={`question10 animated fadeInUp space-top2 ${state.showSlide10} radio-box`}
                    id="breakdown11"
                  >
                    <QuestionnaireFlpFANUpload
                      questArr={questinnare2Very}
                      labelclicked={onselectAnswer}
                      onselectAnswer={onselectAnswer}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      split_name={splitName}
                      docType={docType}
                      documentType={documentType}
                      allFollowupData={allFollowupData}
                      sett2aValidation={sett2aValidation}
                      pushPageChange={pushPageChange}
                    />
                  </div>
                </div>
                <div
                  className={`fade modal blackover space-top2 ${state.loanModal}`}
                  id="breakdown7"
                >
                  <LoanModal
                    saveIncomeExpenditure={saveIncomeExpenditure}
                    validation={register}
                    validationMsg={errors}
                    getValues={getValues}
                    trigger={trigger}
                    setError={setError}
                  />
                </div>
                <div
                  className={`fade modal blackover space-top2 ${state.monthlyModal}`}
                  id="breakdown8"
                >
                  <MonthlyModal
                    saveIncomeExpenditure={saveIncomeExpenditure}
                    validation={register}
                    validationMsg={errors}
                    getValues={getValues}
                    trigger={trigger}
                    setError={setError}
                  />
                </div>
              </form>
            </div>
          </div>
          <QuestionnaireFlpAgreementNoModalV2
            validation={register}
            validationMsg={errors}
            trigger={trigger}
            saveInputAns={saveInputAns}
            agNoShow={agNoShow}
            setDivShow={setDivShow}
            skipAgNo={skipAgNo}
            setAgNoShow={setAgNoShow}
          />
          <AnalyzeModal modalClass={t2aModal} />

        </div>
      </div>
      <QuestionnaireFooter percentage={state.percentage} />
    </>
  );
};

export default VanquisQuestionForm;
